import { Observable, observe, Scope } from 'wdc-cube'
import { PessoaBean } from './pf.types'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class PFScope extends Scope {
    readonly header = new HeaderScope()

    @observe() persons = [] as PessoaBean[]
    @observe() cpfSelected = '' as string

    onFind = Scope.ASYNC_ACTION
}

export default PFScope
